// apiNode.js

import { BaseNode } from './BaseNode';
import { Position } from 'reactflow';

export const ApiNode = ({ id, data }) => {
  const handles = [
    {
      type: 'target',
      position: Position.Left,
      id: `${id}-request`,
      style: { left: '-2px' }
    },
    {
      type: 'source',
      position: Position.Right,
      id: `${id}-response`,
      style: { right: '-2px' }
    }
  ];

  const fields = [
    {
      name: 'url',
      label: 'URL',
      type: 'text',
      defaultValue: data?.url || 'https://api.example.com/data'
    },
    {
      name: 'method',
      label: 'Method',
      type: 'select',
      defaultValue: data?.method || 'GET',
      options: [
        { value: 'GET', label: 'GET' },
        { value: 'POST', label: 'POST' },
        { value: 'PUT', label: 'PUT' },
        { value: 'DELETE', label: 'DELETE' },
        { value: 'PATCH', label: 'PATCH' }
      ]
    },
    {
      name: 'headers',
      label: 'Headers',
      type: 'textarea',
      defaultValue: data?.headers || '{"Content-Type": "application/json"}',
      rows: 2
    }
  ];

  return (
    <BaseNode
      id={id}
      data={data}
      type="api"
      title="API Call"
      handles={handles}
      fields={fields}
      className="max-w-[350px]"
    />
  );
};
